/* Built In Imports */
import { useEffect, useState } from "react";
/* External Imports */
import { Box, Button, Flex, FormControl, Icon, Input, InputGroup, InputLeftAddon } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import SimpleWisdomCard from '@ihs/components/Cards/SimpleWisdomCard';

/* Services */
/* Styles */

/**
 * Renders the TopicBasedWisdomContent component
 *
 * @param data.data
 * @param {object} data -  Related Stories Data
 * @param {object} titleObj - Title data
 * @param {object} lang - Current User Language
 * @returns {ReactElement} TopicBasedWisdomContent component
 */
export default function TopicBasedWisdomContent({
  wisdomData
}) {
  // console.log('wisdomData', wisdomData);
  // setting the searched word here null
  const [searched, setSearched] = useState(null)
  // usestate for filtered items
  const [filtered, setFiltered] = useState(null)
  // setting the limit of cards to show
  const [limit, setLimit] = useState(10)
  // implementing a load more 
  const loadMore = () => {
    setLimit((limit) => limit + 10)
  }
  // slice the array 
  const cardsToShow = wisdomData?.slice(0, limit);

  useEffect(() => {
    if (searched && searched.length > 0) {
      const cards = wisdomData.filter((card) => {
        // return card?.childrens[0]?.title[0]?.value.toLowerCase().includes(searched.toLowerCase())
        return card?.childrens[0]?.title[0]?.value.toLowerCase().indexOf(searched.toLowerCase()) > -1
      })
      // console.log(cards, "filtered", filtered)
      setFiltered(cards)
    }
    else { setFiltered(cardsToShow) }
  }, [searched, limit]);

  // console.log(searched, "searched data")
  return wisdomData?.length > 0 ? (
    <Box
      maxW='670px'
      mx="auto"
      px={{ base: "20px", md: "0" }}
    >
      <FormControl>
        <InputGroup color="#812C12">
          <InputLeftAddon fontSize="24px" pl="0" w="auto" bg="none" border="none" borderBottom="1px solid #3B444B"
            rounded="none" children={<Icon style={{ display: "inline" }} viewBox="0 0 24 24" fill="none">
              {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> */}
              <path d="M20 20L16.05 16.05M18 11C18 14.866 14.866 18 11 18C7.13401 18 4 14.866 4 11C4 7.13401 7.13401 4 11 4C14.866 4 18 7.13401 18 11Z" stroke="#812C12" stroke-width="0.953488" stroke-linecap="square" />
              {/* </svg> */}
            </Icon>} />
          <Input color="#812C12" border="none" borderBottom="1px solid #3B444B"
            rounded="none"
            pl="0"
            lineHeight="30px"
            fontSize="18px"
            fontFamily="Zilla Slab"
            fontWeight={400}
            width={{ base: "100%", md: 600 }}
            _hover={{ borderBottom: "1px solid #3B444B", boxShadow: "none" }}
            _focus={{ boxShadow: "none" }}
            _placeholder={{ color: "#812C12" }}
            value={searched}
            // ref={inputRef}
            // onKeyUp={(e) => { setSearched(e.target.value), console.log(e.target.value, "event target text", searched, "onKeyup"), e.target.value !== searched && setSearched(e.target.value) }}
            // onKeyDown={(e) => { setSearched(e.target.value), console.log(e.target.value, "event target text", searched, "onKeydown"), e.target.value !== searched && setSearched(e.target.value) }}
            onChange={(e) => { setSearched(e.target.value), console.log(e.target.value, "event target text", searched, "onKeychange"), e.target.value !== searched && setSearched(e.target.value) }}
            type="text" placeholder="Search for audio, video or articles" />
        </InputGroup>
      </FormControl>
      <Box
        width="100%"
        pt="40px"
        minH={320}
        mx="0"
      >
        <Flex
          flexWrap="wrap"
          justifyContent="space-between"
          gridColumnGap="20px"
        >

          {!filtered ? cardsToShow.map((post) => {
            return (
              <SimpleWisdomCard
                sectionContent={post}
                wisdomData={wisdomData}
                key={nanoid()}
              />
            );
          }) : filtered.slice(0, limit).map((post) => {
            return (
              <SimpleWisdomCard
                sectionContent={post}
                wisdomData={wisdomData}
                key={nanoid()}
              />
            );
          })}
        </Flex>

        <Flex mt="40px" mb="100px" alignItems="center" justifyContent="center">
          {!filtered?.length || !searched && limit < wisdomData.length ?
            <Button onClick={loadMore} variant="outline" color='#622210' borderColor='#622210' _hover={{ boxShadow: "none" }}
              outline="none"
              mb={{ base: "20px", md: "40px" }}
              _active={{ boxShadow: "none" }}
              w="auto"
              mx="auto"
              _focus={{ boxShadow: "none" }}
              fontFamily="Zilla Slab">
              LOAD MORE  {limit} / {wisdomData.length}
            </Button>
            : ""}
          {searched?.length && filtered.length > 0 && limit < filtered.length ?
            <Button onClick={loadMore} variant="outline" color='#622210' borderColor='#622210' _hover={{ boxShadow: "none" }}
              outline="none"
              w="auto"
              mx="auto"
              mb={{ base: "20px", md: "40px" }}
              _active={{ boxShadow: "none" }}
              _focus={{ boxShadow: "none" }}
              fontFamily="Zilla Slab">
              LOAD MORE  {limit} / {filtered.length}
            </Button>
            : ""}
        </Flex>
      </Box>
    </Box>
  ) : null;
}
